
let back = ['Beszerzés','Alapanyag elhozatal','Visszáru','Alvállalkozótól vissza'];

export function backwards(d){
  if(!d || !d.type) return false;
  if(d.back) return true;
  return back.includes(d.type);
}

// Spark rendeléseknél a BC-ből jövő törzsadatok nem módosíthatók
export function bcLocked(d) {
  return !!d && d.company === 'Spark' && !!d.order;
}
